import React, { useState, useEffect, useRef } from 'react';
import Popper from '@material-ui/core/Popper';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import NotificationsIcon from '@material-ui/icons/Notifications';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { makeStyles } from '@material-ui/core/styles';

import axios from '../../config/axiosInstance';

const useStyles = makeStyles(() => ({
  paper: {
    height: '100%',
  },
  popper: {
    zIndex: 1,
    width: '100%',
    maxWidth: '550px',
    overflowY: 'scroll',
    maxHeight: '94vw',
  },
  number: {
    color: '#537ccd',
    fontWeight: 'bold',
  },
  text: {
    fontSize: '14px',
  },
  notification: {
    backgroundColor: '#537ccd16',
  },
}));

export default function Notification() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [badge, setBadge] = useState(0);
  const prev = usePrevious(badge);

  useEffect(() => {
    async function fetchNotification() {
      const response = await axios.get('/notificationUsers');
      setNotifications(response.data);
      setBadge(response.data.filter(r => r.dtRead === null).length);
    }

    fetchNotification();
  }, []);

  function usePrevious(value) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }


  async function markAsRead() {
    const response = await axios.get('/notificationUsers/markRead');
    setNotifications(response.data);
  }

  function handleClick(event) {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setBadge(0);
    if (badge === 0) {
      markAsRead();
    }
  }

  useEffect(() => {
    if (!anchorEl && prev !== undefined && prev > 0) {
      //     markAsRead();
      //  notifications && setNotifications(notifications.map(r => (r.dtRead === null ? 'not null' : r.dtRead)));
    }
  }, [anchorEl, prev, notifications]);


  function handleClickAway() {
    setAnchorEl(null);
  }

  const open = Boolean(anchorEl);
  const id = open ? 'notifications' : undefined;

  return (
    <div>
      <ClickAwayListener onClickAway={handleClickAway}>
        <>
          <IconButton color="primary" onClick={handleClick} aria-describedby={id} style={{ bottom: '-6%' }}>
            <Badge badgeContent={badge} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>

          <Popper
            id={id}
            open={open}
            anchorEl={anchorEl}
            transition
            className={classes.popper}
            placement="bottom-end"
            modifiers={{
              flip: {
                enabled: false,
              }
            }}
          >
            {({ TransitionProps }) => (
              <Fade {...TransitionProps} timeout={350}>
                <Paper elevation={2} className={classes.paper} style={{width:'550px'}}>
                  <List aria-label="lista de notificações" >
                    <Typography className={classes.text} style={{ marginLeft: 16, paddingTop: 12, paddingBottom: 12 }}>
                      Você tem <span className={classes.number}>{prev}</span> novas notificações
                    </Typography>
                    {[...notifications].map(n => (
                      <React.Fragment key={n.id}>
                        <Divider />
                        <ListItem className={n.dtRead ? null : 'classes.notification'}>
                          <Typography className={classes.text}>
                            <strong> {n.notification.title} </strong><br/>
                            <span style={{ color: 'black' }} dangerouslySetInnerHTML={{ __html: n.notification.description }} />
                          </Typography>
                        </ListItem>
                      </React.Fragment>
                    ))}
                  </List>
                </Paper>
              </Fade>
            )}
          </Popper>
        </>
      </ClickAwayListener>
    </div>
  );
}
